import { Routes } from '@angular/router';
import { MainPageComponent } from './components/main-page/main-page.component';
import { PrivacyComponent } from './components/policies/privacy/privacy.component';
import { TermsComponent } from './components/policies/terms/terms.component';

export const routes: Routes = [
  {
    path: '',
    component: MainPageComponent
  },
  {
    path: 'privacy',
    component: PrivacyComponent
  },
  {
    path: 'terms',
    component: TermsComponent
  }
];
